import React, { useState } from "react";
import PropTypes from "prop-types";
import cardEx from "../../../assets/home/cardEx.png";
import personEx from "../../../assets/home/person.png";
import start from "../../../assets/home/star.png";
import starDisable from "../../../assets/home/starDisable.png";
import folder from "../../../assets/home/folder.png";
import like from "../../../assets/home/like.png";

// * Style
import "../../../styles/designCard.scss";

// * Images
// ! Temporarily images
import placholderImage from "../../../assets/designCard/example.png";
import avatar from "../../../assets/designCard/avatar.png";

const DesignCard = (props) => {
  const {
    id,
    image,
    designId,
    title,
    designerId,
    designerAvatar,
    designerName,
    onLiked,
    onDesignerClick,
    onDesignClick,
  } = props;

  const points = [
    { value: start },
    { value: start },
    { value: start },
    { value: start },
    { value: starDisable },
  ];

  const [liked, setLiked] = useState(props.liked);
  const likeClassNames = ["design-card__like"];

  const handleDesignerClick = () => {
    onDesignerClick(designerId);
  };

  const handleDesignClick = () => {
    onDesignClick(designId);
  };

  const handleLikeClick = () => {
    onLiked(id, !liked);
    setLiked(!liked);
  };

  if (liked) likeClassNames.push("design-card__like--active");

  return (
    <div className="design-card">
      <div style={{ position: "relative" }}>
        <img
          src={cardEx}
          alt={title}
          onClick={handleDesignClick}
          height="295px"
          width="295px"
        />
        <img
          className="design-card__avatar"
          src={personEx}
          alt="avatar"
          width={40}
          height={40}
          onClick={handleDesignerClick}
        />

        <label className="design-card__name">Student</label>
      </div>

      <div className="design-card__content">
        <div className="design-card__point">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "6px",
            }}
          >
            {points.map(({ value }, index) => (
              <img src={value} width="18px" height="18px" key={index}></img>
            ))}
            <label className="design-card__point-number">(400)</label>
          </div>
          <label
            style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}
          >
            <img src={folder} width="18px" height="18px"></img>
            <img src={like} width="18px" height="18px"></img>
          </label>
        </div>
        <label className="design-card__company">
          XYZ Construction co.,LDT.
        </label>
        <div className="design-card__detail">
          <label className="design-card__topic">Project</label>
          <label style={{ color: "#5C5C5C" }}>:</label>
          <label className="design-card__value">Manhattan Village</label>
        </div>
        <div className="design-card__detail">
          <label className="design-card__topic">Area</label>
          <label style={{ color: "#5C5C5C" }}>:</label>
          <label className="design-card__value">500 Sqm.</label>
        </div>
        {/* <img
          className="design-card__avatar"
          src={avatar}
          alt="avatar"
          width={40}
          height={40}
          onClick={handleDesignerClick}
        /> */}
        {/* <label className="design-card__title" onClick={handleDesignClick}>
          {title}
        </label>
        <label
          className="design-card__desginer-name"
          onClick={handleDesignerClick}
        >
          {designerName}
        </label> */}
        {/* <div className={likeClassNames.join(" ")} onClick={handleLikeClick}>
          <svg
            width="20"
            height="19"
            viewBox="0 0 20 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10 18.35L8.55 17.03C3.4 12.36 0 9.27 0 5.5C0 2.41 2.42 0 5.5 0C7.24 0 8.91 0.81 10 2.08C11.09 0.81 12.76 0 14.5 0C17.58 0 20 2.41 20 5.5C20 9.27 16.6 12.36 11.45 17.03L10 18.35Z" />
          </svg>
        </div> */}
      </div>
    </div>
  );
};

DesignCard.propTypes = {
  image: PropTypes.string.isRequired,
  designId: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  designerId: PropTypes.string.isRequired,
  designerAvatar: PropTypes.string.isRequired,
  designerName: PropTypes.string.isRequired,
  liked: PropTypes.bool,
  onLiked: PropTypes.func,
  onDesignerClick: PropTypes.func,
  onDesignClick: PropTypes.func,
};

DesignCard.defaultProps = {
  liked: false,
  onLiked: () => {},
  onDesignerClick: () => {},
  onDesignClick: () => {},
};

export default DesignCard;
